import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { HelpCircle } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Tengo que dejar de comer carne?',
    a: 'No, solo aprenderás cuándo y cómo sazonarla.'
  }, {
    q: '¿Es difícil conseguir los ingredientes?',
    a: 'No, todo se encuentra en tu supermercado local.'
  }, {
    q: '¿Funciona si ya tomo medicamentos?',
    a: 'Sí, este manual trabaja en la mecánica digestiva, no interfiere con fármacos, pero consulta a tu médico antes de dejar cualquier tratamiento.'
  }];
  return <SectionWrapper bgColor="cream" data-id="element-23">
      <div className="flex items-center justify-center gap-3 mb-10" data-id="element-24">
        <HelpCircle className="w-8 h-8 text-brand-forest" data-id="element-25" />
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-forest text-center" data-id="element-26">
          Preguntas Frecuentes
        </h2>
      </div>

      <div className="space-y-6 max-w-3xl mx-auto" data-id="element-27">
        {faqs.map((faq, index) => <div key={index} className="bg-white p-6 md:p-8 rounded-2xl shadow-sm" data-id="element-28">
            <h3 className="font-bold text-xl text-brand-forest mb-3" data-id="element-29">
              {faq.q}
            </h3>
            <p className="text-lg text-gray-700" data-id="element-30">{faq.a}</p>
          </div>)}
      </div>
    </SectionWrapper>;
}